<div class="flex flex-col bg-no-repeat bg-cover bg-center px-2 py-2 md:py-4 md:px-8 lg:px-12 lg:py-4"
     style="background-image: url('/assets/images/body.webp');">
  <div class="w-full flex justify-center mb-4 mt-8 md:mt-12 lg:mt-0 order-2 lg:order-1">
    <app-top-navbar class="w-full max-w-8xl"></app-top-navbar>
  </div>

  <div class="w-full flex justify-center mb-6 order-1 lg:order-2">
    <app-navbar class="w-full max-w-8xl"></app-navbar>
  </div>

  <div class="w-full max-w-6xl mx-auto order-3 flex flex-col gap-2">
    @if (getOrderTypeLabel() && getFormattedLocation().text) {
    <div class="flex items-center justify-center h-auto">
      <div class="address-pill">
        <div class="type-section">
          <p class="type-text" [class.text-primary]="isMilano" [class.text-base]="!isMilano">
    {{ getOrderTypeLabel() }}
    </p>
    @if (isDelivery) {
    <p class="delay-text">Délai : {{ formatDeliveryDelay() }}</p>
    }
    </div>
    <div class="location-section" [class.bg-primary]="isMilano" [class.bg-secondary/20]="!isMilano">
      <div class="location-info">
        <p class="location-address">{{ getFormattedLocation().text }}</p>
              @if (getMinOrderAmount()) {
    <p class="min-amount">{{ getMinOrderAmount() }}</p>
    }
    </div>
    <button (click)="openDialog()" class="edit-action">
      <mat-icon>edit</mat-icon>
    </button>
  </div>
</div>
</div>
    }
    <span class="font-normal text-[18px] text-center md:text-[28px] text-[#FFFFFF] text">
      Commandez vos plats préférés en quelques clics ! 😋
    </span>
  </div>
</div>

<div class="py-4 px-4 md:px-8 lg:px-12">
  @if (isLoading()) {
  <div class="flex justify-center items-center min-h-[400px]">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-secondary"></div>
    <span class="ml-2 text-gray-600">Chargement en cours ...</span>
  </div>
  }

  @if (promoSignal() && !isLoading(); as promotion) {
  <div>
@if (isPointsPromo) {

  <!-- ==================== PROMO POINTS - MOBILE (< 768px) ==================== -->
  <div class="md:hidden space-y-6">
    <div class="bg-base-200 rounded-lg p-3 flex items-center gap-4">
      <img [ngSrc]="promoSignal()?.image || 'assets/images/promos.webp'"
           [alt]="promoSignal()?.title || 'Image à venir'" width="80" height="80" loading="lazy"
           class="rounded-lg object-contain">
      <div>
        <h1 class="text-xl font-semibold">{{ promoSignal()?.title }}</h1>
        <p class="text-sm text-site">Choisissez <b>une seule</b> offre parmi les options ci-dessous.</p>
        @if (loyaltyBalance() === null) {
        <p class="text-sm text-red-500">Connectez-vous pour utiliser vos points.</p>
        } @else {
        <p class="text-sm font-semibold text-primary">Points disponibles : {{ availablePoints }} pts</p>
        }
      </div>
    </div>

    <!-- RÈGLES MOBILE -->
    <div class="space-y-4">
      @for (rule of promoSignal()?.payload?.rules; track rule.id) {
      @let selected = selectedRuleId === rule.id;
      @let affordable = canAffordRule(rule);
      <div class="rounded-lg border-2 transition-all bg-base-200"
           [class.border-secondary]="selected"
           [class.border-gray-300]="!selected"
           [class.opacity-60]="!affordable && !selected">

        <button type="button" class="w-full p-4 flex items-center justify-between gap-3 text-left"
                (click)="selectRule(rule)">
          <div class="min-w-0">
 <h3 class="text-[20px] font-semibold text-[#FF730A]">
      {{ rule.category.name }}
      @if (rule.sizes?.length) {
      <span class="text-gray-600 text-[15px] font-normal">({{ getSizesText(rule.sizes) }})</span>
      }
      </h3>
                  <div class="flex flex-wrap items-center gap-2 mt-1">
                    <span class="bg-primary text-white text-xs font-bold px-2 py-1 rounded-full">
      {{ rule.loyaltyPoints }} pts
                </span>
                @if (getRuleDiscountLabel(rule)) {
      <span class="text-green-600 text-xs font-semibold bg-green-50 px-2 py-1 rounded">
                    {{ getRuleDiscountLabel(rule) }}
                  </span>
      }
      @if (!affordable) {
      <span class="text-red-600 text-xs font-semibold bg-red-50 px-2 py-1 rounded">
                    Points insuffisants
                  </span>
      }
      </div>
    </div>
    @if (selected) {
      <div class="w-6 h-6 shrink-0 rounded-full bg-secondary flex items-center justify-center">
        <mat-icon class="text-white text-sm">check</mat-icon>
      </div>
      } @else {
      <div class="w-6 h-6 shrink-0 rounded-full border-2 border-gray-400"></div>
      }
      </button>

    @if (selected) {
      <div class="px-3 pb-4 pt-2 border-t border-gray-300 space-y-4">
        <p class="text-sm text-gray-600 mb-2">
          Sélectionnés : {{ getTotalQuantityForRule(rule.id) }}/{{ rule.quantity }}
        </p>

        <!-- Boucle sur chaque catégorie de la règle sélectionnée -->
        @for (categoryGroup of rule.categoriesDetails; track categoryGroup.id) {
        <div class="space-y-2">
          <!-- Nom de la sous-catégorie (ex: 1 Sandwichs / 1 NosTacos) -->
<h4 class="text-md font-semibold text-gray-800 border-b border-gray-200 pb-1 flex items-center justify-between">
  <div>
    <span>{{ categoryGroup.quantity }} {{ categoryGroup.name }}</span>
    @if (categoryGroup.sizes?.length) {
        <span class="text-sm font-normal text-gray-500 ml-1">({{ getSizesText(categoryGroup.sizes) }})</span>
        }
        </div>
        <span class="text-xs text-gray-400 font-normal">
          ({{ getQuantityForCategory(rule.id, categoryGroup) }}/{{ categoryGroup.quantity }})
  </span>
</h4>

        <!-- Liste des produits de CETTE catégorie -->
        <div class="grid grid-cols-1 2xl:grid-cols-2 gap-3">
          @for (product of categoryGroup.products; track product.id) {
        <div class="relative flex items-center justify-between px-[14px] py-2 bg-white border border-[#E7E7E7] rounded-[6px]"
             [class.border-orange-500]="getItemQuantity(rule.id, product.id) > 0">

          <span class="text-base text-site font-medium break-words flex-1 min-w-0">{{ product.name }}</span>

          <div class="flex items-center gap-2 shrink-0 mx-3">
            <button type="button"
                    (click)="decrementItem(rule.id, product.id)"
                    [disabled]="getItemQuantity(rule.id, product.id) === 0"
                    class="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">-</button>

            <span class="font-bold min-w-[20px] text-center text-site">{{ getItemQuantity(rule.id, product.id) }}</span>

            <button type="button"
                    (click)="incrementItem(rule.id, product.id)"
                    [disabled]="product.available === false"
                    class="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">+</button>
          </div>

          @if (product.image) {
          <img [ngSrc]="product.image" [alt]="product.name" width="56" height="56" loading="lazy" class="rounded-lg shrink-0 object-contain">
          }
        </div>
        }
        </div>
      </div>
        }
      </div>
      }
      </div>
      }
    </div>

    <!-- BOTTOM BAR MOBILE -->
    <div class="fixed bottom-0 left-0 right-0 bg-[#2B150575] backdrop-blur-md border-b border-orange-900/30 border-t mx-[16px] shadow-lg p-2 z-50">
      @if (!canAddToCart()) {
      <p class="text-[#FF730A] text-xs text-center mb-1 font-medium">{{ getValidationMessage() }}</p>
      }
      <div class="flex items-center justify-center">
        <button (click)="toggleCartSheet()" [disabled]="!canAddToCart()" [class.disabled]="!canAddToCart()"
                class="add bg-[#FF730A] text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 w-full justify-center">
          <span>Voir détails</span>
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== PROMO POINTS - TABLETTE (768px à 1280px) ==================== -->
  <div class="hidden md:flex xl:hidden gap-4">
    <div class="w-1/3 flex-shrink-0">
      <div class="sticky top-4 bg-base-200 rounded-lg p-4 space-y-3">
        <div class="flex items-center gap-3">
          <img [ngSrc]="promoSignal()?.image || 'assets/images/promos.webp'"
               [alt]="promoSignal()?.title || 'Image à venir'" width="64" height="64" loading="lazy"
               class="rounded-lg object-contain">
          <div>
            <h1 class="text-lg font-semibold">{{ promoSignal()?.title }}</h1>
            @if (loyaltyBalance() === null) {
            <p class="text-xs text-red-500">Connectez-vous pour vos points.</p>
            } @else {
            <p class="text-xs font-semibold text-primary">Points : {{ availablePoints }} pts</p>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- RÈGLES TABLETTE -->
    <div class="flex-1 space-y-4">
      @for (rule of promoSignal()?.payload?.rules; track rule.id) {
      @let selected = selectedRuleId === rule.id;
      @let affordable = canAffordRule(rule);
      <div class="rounded-lg border-2 transition-all bg-base-200"
           [class.border-secondary]="selected"
           [class.border-gray-300]="!selected"
           [class.opacity-60]="!affordable && !selected">

        <button type="button" class="w-full p-4 flex items-center justify-between gap-3 text-left"
                (click)="selectRule(rule)">
          <div class="min-w-0">
 <h3 class="text-[20px] font-semibold text-[#FF730A]">
      {{ rule.category.name }}
      @if (rule.sizes?.length) {
      <span class="text-gray-600 text-[15px] font-normal">({{ getSizesText(rule.sizes) }})</span>
      }
      </h3>
                  <div class="flex flex-wrap items-center gap-2 mt-1">
                    <span class="bg-primary text-white text-xs font-bold px-2 py-1 rounded-full">
      {{ rule.loyaltyPoints }} pts
                </span>
                @if (getRuleDiscountLabel(rule)) {
      <span class="text-green-600 text-xs font-semibold bg-green-50 px-2 py-1 rounded">
                    {{ getRuleDiscountLabel(rule) }}
                  </span>
      }
      @if (!affordable) {
      <span class="text-red-600 text-xs font-semibold bg-red-50 px-2 py-1 rounded">
                    Points insuffisants
                  </span>
      }
      </div>
    </div>
    @if (selected) {
      <div class="w-6 h-6 shrink-0 rounded-full bg-secondary flex items-center justify-center">
        <mat-icon class="text-white text-sm">check</mat-icon>
      </div>
      } @else {
      <div class="w-6 h-6 shrink-0 rounded-full border-2 border-gray-400"></div>
      }
      </button>

  @if (selected) {
      <div class="px-3 pb-4 pt-2 border-t border-gray-300 space-y-4">
        <p class="text-sm text-gray-600 mb-2">
          Sélectionnés : {{ getTotalQuantityForRule(rule.id) }}/{{ rule.quantity }}
        </p>

        <!-- Boucle sur chaque catégorie de la règle sélectionnée -->
        @for (categoryGroup of rule.categoriesDetails; track categoryGroup.id) {
        <div class="space-y-2">
          <!-- Nom de la sous-catégorie (ex: 1 Sandwichs / 1 NosTacos) -->
 <h4 class="text-md font-semibold text-gray-800 border-b border-gray-200 pb-1 flex items-center justify-between">
  <div>
    <span>{{ categoryGroup.quantity }} {{ categoryGroup.name }}</span>
    @if (categoryGroup.sizes?.length) {
        <span class="text-sm font-normal text-gray-500 ml-1">({{ getSizesText(categoryGroup.sizes) }})</span>
        }
        </div>
        <span class="text-xs text-gray-400 font-normal">
          ({{ getQuantityForCategory(rule.id, categoryGroup) }}/{{ categoryGroup.quantity }})
  </span>
</h4>

        <!-- Liste des produits de CETTE catégorie -->
        <div class="grid grid-cols-1 2xl:grid-cols-2 gap-3">
          @for (product of categoryGroup.products; track product.id) {
        <div class="relative flex items-center justify-between px-[14px] py-2 bg-white border border-[#E7E7E7] rounded-[6px]"
             [class.border-orange-500]="getItemQuantity(rule.id, product.id) > 0">

          <span class="text-base text-site font-medium break-words flex-1 min-w-0">{{ product.name }}</span>

          <div class="flex items-center gap-2 shrink-0 mx-3">
            <button type="button"
                    (click)="decrementItem(rule.id, product.id)"
                    [disabled]="getItemQuantity(rule.id, product.id) === 0"
                    class="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">-</button>

            <span class="font-bold min-w-[20px] text-center text-site">{{ getItemQuantity(rule.id, product.id) }}</span>

            <button type="button"
                    (click)="incrementItem(rule.id, product.id)"
                    [disabled]="product.available === false"
                    class="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">+</button>
          </div>

          @if (product.image) {
          <img [ngSrc]="product.image" [alt]="product.name" width="56" height="56" loading="lazy" class="rounded-lg shrink-0 object-contain">
          }
        </div>
        }
        </div>
      </div>
        }
      </div>
      }
      </div>
      }
    </div>

    <!-- BOTTOM BAR TABLETTE -->
    <div class="fixed bottom-0 left-0 right-0 bg-[#2B150575] backdrop-blur-md border-b border-orange-900/30 border-t mx-[16px] shadow-lg p-2 z-50">
      @if (!canAddToCart()) {
      <p class="text-[#FF730A] text-xs text-center mb-1 font-medium">{{ getValidationMessage() }}</p>
      }
      <div class="flex items-center justify-center">
        <button (click)="toggleCartSheet()" [disabled]="!canAddToCart()" [class.disabled]="!canAddToCart()"
                class="add bg-[#FF730A] text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 w-full justify-center">
          <span>Voir détails</span>
        </button>
      </div>
    </div>
  </div>

  <!-- ==================== PROMO POINTS - DESKTOP EN 3 COLONNES (≥ 1280px) ==================== -->
  <div class="hidden xl:grid grid-cols-[280px_1fr_320px] gap-6">

    <!-- COLONNE 1 : IMAGE & INFOS D'ENTÊTE -->
    <div class="w-full flex-shrink-0">
      <div class="sticky top-4 bg-base-200 p-4 rounded-lg space-y-4 shadow-sm">
        <div class="relative w-full aspect-square">
          <img [ngSrc]="promoSignal()?.image || 'assets/images/promos.webp'"
               [alt]="promoSignal()?.title || 'Image à venir'"
               fill loading="lazy" sizes="33vw" class="rounded-lg object-contain">
        </div>
        <div>
          <h1 class="text-xl font-semibold mb-1">{{ promoSignal()?.title }}</h1>
          <p class="text-sm text-site mb-2">Choisissez <b>une seule</b> offre parmi les options ci-dessous.</p>
          @if (loyaltyBalance() === null) {
          <p class="text-sm text-red-500">Connectez-vous pour utiliser vos points.</p>
          } @else {
          <p class="text-sm font-semibold text-primary">Points disponibles : {{ availablePoints }} pts</p>
          }
        </div>
      </div>
    </div>

    <!-- COLONNE 2 : CHOIX DES RÈGLES / PRODUITS -->
    <div class="space-y-4">
      @for (rule of promoSignal()?.payload?.rules; track rule.id) {
      @let selected = selectedRuleId === rule.id;
      @let affordable = canAffordRule(rule);
      <div class="rounded-lg border-2 transition-all bg-base-200"
           [class.border-secondary]="selected"
           [class.border-gray-300]="!selected"
           [class.opacity-60]="!affordable && !selected">

        <button type="button" class="w-full p-4 flex items-center justify-between gap-3 text-left"
                (click)="selectRule(rule)">
          <div class="min-w-0">
  <h3 class="text-[20px] font-semibold text-[#FF730A]">
      {{ rule.category.name }}
      @if (rule.sizes?.length) {
      <span class="text-gray-600 text-[15px] font-normal">({{ getSizesText(rule.sizes) }})</span>
      }
      </h3>
                  <div class="flex flex-wrap items-center gap-2 mt-1">
                    <span class="bg-primary text-white text-xs font-bold px-2 py-1 rounded-full">
      {{ rule.loyaltyPoints }} pts
                </span>
                @if (getRuleDiscountLabel(rule)) {
      <span class="text-green-600 text-xs font-semibold bg-green-50 px-2 py-1 rounded">
                    {{ getRuleDiscountLabel(rule) }}
                  </span>
      }
      @if (!affordable) {
      <span class="text-red-600 text-xs font-semibold bg-red-50 px-2 py-1 rounded">
                    Points insuffisants
                  </span>
      }
      </div>
    </div>
    @if (selected) {
      <div class="w-6 h-6 shrink-0 rounded-full bg-secondary flex items-center justify-center">
        <mat-icon class="text-white text-sm">check</mat-icon>
      </div>
      } @else {
      <div class="w-6 h-6 shrink-0 rounded-full border-2 border-gray-400"></div>
      }
      </button>

      @if (selected) {
      <div class="px-3 pb-4 pt-2 border-t border-gray-300 space-y-4">
        <p class="text-sm text-gray-600 mb-2">
          Sélectionnés : {{ getTotalQuantityForRule(rule.id) }}/{{ rule.quantity }}
        </p>

        <!-- Boucle sur chaque catégorie de la règle sélectionnée -->
        @for (categoryGroup of rule.categoriesDetails; track categoryGroup.id) {
        <div class="space-y-2">
          <!-- Nom de la sous-catégorie (ex: 1 Sandwichs / 1 NosTacos) -->
    <h4 class="text-md font-semibold text-gray-800 border-b border-gray-200 pb-1 flex items-center justify-between">
  <div>
    <span>{{ categoryGroup.quantity }} {{ categoryGroup.name }}</span>
    @if (categoryGroup.sizes?.length) {
        <span class="text-sm font-normal text-gray-500 ml-1">({{ getSizesText(categoryGroup.sizes) }})</span>
        }
        </div>
        <span class="text-xs text-gray-400 font-normal">
          ({{ getQuantityForCategory(rule.id, categoryGroup) }}/{{ categoryGroup.quantity }})
  </span>
</h4>

        <!-- Liste des produits de CETTE catégorie -->
        <div class="grid grid-cols-1 2xl:grid-cols-2 gap-3">
          @for (product of categoryGroup.products; track product.id) {
        <div class="relative flex items-center justify-between px-[14px] py-2 bg-white border border-[#E7E7E7] rounded-[6px]"
             [class.border-orange-500]="getItemQuantity(rule.id, product.id) > 0">

          <span class="text-base text-site font-medium break-words flex-1 min-w-0">{{ product.name }}</span>

          <div class="flex items-center gap-2 shrink-0 mx-3">
            <button type="button"
                    (click)="decrementItem(rule.id, product.id)"
                    [disabled]="getItemQuantity(rule.id, product.id) === 0"
                    class="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">-</button>

            <span class="font-bold min-w-[20px] text-center text-site">{{ getItemQuantity(rule.id, product.id) }}</span>

            <button type="button"
                    (click)="incrementItem(rule.id, product.id)"
                    [disabled]="product.available === false"
                    class="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">+</button>
          </div>

          @if (product.image) {
          <img [ngSrc]="product.image" [alt]="product.name" width="56" height="56" loading="lazy" class="rounded-lg shrink-0 object-contain">
          }
        </div>
        }
        </div>
      </div>
        }
      </div>
      }
      </div>
      }
    </div>

    <!-- COLONNE 3 : PANIER / RÉCAPITULATIF STICKY -->
    <div class="w-full flex-shrink-0">
      <div class="sticky top-4 bg-base-200 rounded-[10px] p-4 space-y-3 shadow-md">
        <h2 class="font-semibold title">{{ promoSignal()?.title }}</h2>

        @if (getSelectedRule(); as rule) {
        <div class="flex justify-between text-sm">
          <span>Coût en points</span>
          <span class="font-bold text-primary">{{ rule.loyaltyPoints }} pts</span>
          </div>


          @for (item of getSelectedBuyItems(); track item.product.id) {
        @for (i of [].constructor(item.quantity); track $index; let index = $index) {
        <div class="bg-base-300 rounded-[6px] p-2 text-sm">
          <div class="flex justify-between items-start">
            <div>
              <span class="font-medium">{{ item.product.name }}</span>
                    @if (customizableItems[item.rule.id + '_' + item.product.id]) {
        <div>
                        <span (click)="openProductCustomization(item.product, item.rule.id, index)"
                              class="text-xs underline cursor-pointer"
                              [class.text-red-600]="hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)"
                              [class.text-[#888888]]="!hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)">
                          {{ isItemCustomized(item.rule.id, item.product.id, index) ? 'Modifier' : 'Personnaliser' }}
                        </span>
        </div>
        }
        </div>
        <mat-icon class="material-symbols-outlined cursor-pointer text-red-500 hover:text-red-700"
                  (click)="removeItem(item.rule.id, item.product.id, index)">delete</mat-icon>
      </div>
      @if (getCustomizationSummary(item.rule.id, item.product.id, index).trim() !== '') {
        <div class="text-xs text-gray-400 mt-1 whitespace-pre-line">
          {{ getCustomizationSummary(item.rule.id, item.product.id, index).replaceAll('[CAT]', '').replaceAll('|||', ', ') }}
        </div>
        }
        </div>
        }
        }

        <div class="border-t border-gray-300 pt-2 space-y-1 text-sm">
          @if (getTotalSupplementsPrice() > 0) {
        <div class="flex justify-between">
          <span>Suppléments</span>
          <span class="text-green-600">+{{ truncate2(getTotalSupplementsPrice()) | number:'1.2-2' }}€</span>
        </div>
        }
        <div class="flex justify-between font-bold text-lg">
       <span>Reste à payer</span>
       @if (isPointsPromo) {
        <span>{{ formatPointsTotal() }}</span>
        } @else {
        <span>{{ calculatePromotionTotal() | number:'1.2-2' }}€</span>
        }
        </div>
                  </div>
        } @else {
        <p class="text-center text-gray-400 text-sm py-4">Choisissez une offre</p>
        }

        <button [matButton]="themeConfig.appearance.button.action"
                [disabled]="!canAddToCart() || isSubmitting()" class="w-full py-2" (click)="addToCart()">
          Ajouter avec mes points
        </button>

        @if (getValidationMessage() !== '') {
        <p class="text-sm text-red-500 flex items-center">
          <mat-icon class="material-symbols-outlined text-sm mr-1">warning</mat-icon>
        {{ getValidationMessage() }}
        </p>
        }
      </div>
    </div>
  </div>

  <!-- ==================== BOTTOM SHEET RECAP (MOBILE / TABLETTE) ==================== -->
  @if (isCartSheetOpen) {
  <div class="fixed inset-0 z-[60] xl:hidden" (click)="toggleCartSheet()">
    <div class="absolute inset-0 bg-neutral transition-opacity duration-300"
         [class.opacity-50]="isCartSheetOpen" [class.opacity-0]="!isCartSheetOpen"></div>
    <div (click)="$event.stopPropagation()"
         class="absolute bottom-0 left-0 right-0 bg-base-200 rounded-t-2xl shadow-2xl max-h-[85vh] flex flex-col">
      <div class="flex justify-end pt-3 pr-3">
        <mat-icon class="text-gray-300 cursor-pointer" (click)="toggleCartSheet()">close</mat-icon>
      </div>
      <div class="p-4 space-y-3">
        <h2 class="font-semibold title">{{ promoSignal()?.title }}</h2>

          @if (getSelectedRule(); as rule) {
  <div class="flex justify-between text-sm">
    <span>Coût en points</span>
    <span class="font-bold text-primary">{{ rule.loyaltyPoints }} pts</span>
  </div>
  @for (item of getSelectedBuyItems(); track item.product.id) {
  @for (i of [].constructor(item.quantity); track $index; let index = $index) {
  <div class="bg-base-300 rounded-[6px] p-2 text-sm">
    <div class="flex justify-between items-start">
      <div>
        <span class="font-medium">{{ item.product.name }}</span>
        @if (customizableItems[item.rule.id + '_' + item.product.id]) {
        <div>
          <span (click)="openProductCustomization(item.product, item.rule.id, index); $event.stopPropagation()"
                class="text-xs underline cursor-pointer"
                [class.text-red-600]="hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)"
                [class.text-[#888888]]="!hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)">
        {{ isItemCustomized(item.rule.id, item.product.id, index) ? 'Modifier' : 'Personnaliser' }}
        </span>
      </div>
        }
      </div>
      <mat-icon class="material-symbols-outlined cursor-pointer text-red-500 hover:text-red-700"
                (click)="removeItem(item.rule.id, item.product.id, index)">delete</mat-icon>
    </div>
    @if (getCustomizationSummary(item.rule.id, item.product.id, index).trim() !== '') {
    <div class="text-xs text-gray-400 mt-1 whitespace-pre-line">
    {{ getCustomizationSummary(item.rule.id, item.product.id, index).replaceAll('[CAT]', '').replaceAll('|||', ', ') }}
    </div>
    }
  </div>
  }
  }

  <div class="border-t border-gray-300 pt-2 space-y-1 text-sm">
    @if (getTotalSupplementsPrice() > 0) {
    <div class="flex justify-between">
      <span>Suppléments</span>
      <span class="text-green-600">+{{ truncate2(getTotalSupplementsPrice()) | number:'1.2-2' }}€</span>
                </div>
    }
    <div class="flex justify-between font-bold text-lg">
      <span>Reste à payer</span>
      @if (isPointsPromo) {
      <span>{{ formatPointsTotal() }}</span>
      } @else {
      <span>{{ calculatePromotionTotal() | number:'1.2-2' }}€</span>
      }
    </div>
  </div>
  } @else {
  <p class="text-center text-gray-400 text-sm py-4">Choisissez une offre</p>
  }

  <button [matButton]="themeConfig.appearance.button.action"
          [disabled]="!canAddToCart() || isSubmitting()" class="w-full py-2" (click)="addToCart()">
    Ajouter avec mes points
  </button>

  @if (getValidationMessage() !== '') {
  <p class="text-sm text-red-500 flex items-center">
    <mat-icon class="material-symbols-outlined text-sm mr-1">warning</mat-icon>
    {{ getValidationMessage() }}
  </p>
  }
  </div>
</div>
</div>
  }

  }
  @else {
  <!-- ==================== PROMO STANDARD ==================== -->

  <!-- --- AFFICHAGE MOBILE --- -->
  <div class="md:hidden space-y-6">
    <div class="content-card bg-base-200 rounded-lg p-2">
      <div class="flex items-center gap-3">
        <img [ngSrc]="promoSignal()?.image || 'assets/images/promos.webp'"
             [alt]="promoSignal()?.title || 'Image à venir'"
             width="80" height="80" loading="lazy">
        <h1 class="text-xl font-semibold text-center">{{ promoSignal()?.title }}</h1>
      </div>
    </div>

    @if (promoSignal()?.payload?.cheapestOffered === true) {
    <div class="bg-[#fcf8e3] border-l-4 border-l-[#8a6d3b] flex items-center mb-0 gap-3 p-3">
      <mat-icon class="warning">warning</mat-icon>
      <p class="text-[#8a6d3b]">La moins chère sera offerte</p>
    </div>
    }

    <div class="space-y-6">
      @if (hasProductsToBuy()) {
      <div>
        @if (promoSignal()?.payload?.cheapestOffered === false) {
      <h2 class="text-[28px] text-[#FF730A] font-bold mb-0 title">Produits Achetés</h2>
      }
      @for (rule of promoSignal()?.payload?.rules; track trackItem(rule.id, ruleIndex); let ruleIndex = $index) {
      @if (!rule.offered) {
      <div [attr.id]="'mobile-rule-' + ruleIndex">
        <h3 class="text-[22px] text-[#FF730A] font-semibold mb-4">
      {{ rule.quantity }} {{ rule.category.name }}
      @if (rule.sizes && rule.sizes.length > 0) {
      <span class="text-gray-600 text-[15px]">({{ getSizesText(rule.sizes) }})</span>
      }
      </h3>
      <div class="grid 2xl:grid-cols-2 gap-6">
        @for (product of rule.products; track product.id) {
      <div class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
           [class.border-orange-500]="getItemQuantity(rule.id, product.id) > 0"
           [class.shadow-md]="getItemQuantity(rule.id, product.id) > 0"
           [class.opacity-60]="product.available === false"
           [class.cursor-not-allowed]="product.available === false"
           [class.cursor-pointer]="product.available === true">
        @if (product.available === false) {
        <span class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
          Non disponible
        </span>
        }
        <div class="flex items-center space-x-3 flex-1 min-w-0">
          <div class="flex-1 min-w-0">
            <span class="text-base text-site font-medium break-words">{{ product.name }}</span>
            <span class="text-sm text-site font-normal">({{ getProductPrice(product, rule) | number:'1.2-2' }}€)</span>
          </div>
        </div>
        <div class="flex items-center gap-2 flex-shrink-0 mr-3">
          <button (click)="decrementItem(rule.id, product.id)"
                  [disabled]="getItemQuantity(rule.id, product.id) === 0"
                  class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">-</button>
          <span class="font-bold min-w-[20px] text-center text-site">{{ getItemQuantity(rule.id, product.id) }}</span>
          <button [disabled]="product.available === false"
                  (click)="incrementItem(rule.id, product.id, ruleIndex)"
                  class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">+</button>
        </div>
        @if (product.image) {
        <img [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
             [alt]="product.name || 'Image à venir'"
             width="64" height="64" loading="lazy" class="rounded-lg flex-shrink-0">
        }
      </div>
      }
      </div>
    </div>
      }
      }
      </div>
      }

      @if (hasOfferedProducts()) {
      <div>
        @if (promoSignal()?.payload?.cheapestOffered === false) {
      <h2 class="text-[28px] text-[#FF730A] title font-bold mb-0">Produits Offerts</h2>
      }
      @for (rule of promoSignal()?.payload?.rules; track trackItem(rule.id, ruleIndex); let ruleIndex = $index) {
      @if (rule.offered) {
      <div [attr.id]="'mobile-rule-' + ruleIndex">
        <h3 class="text-[22px] text-[#FF730A] font-semibold mb-4">
        {{ rule.quantity }} {{ rule.category.name }}
        @if (rule.sizes && rule.sizes.length > 0) {
      <span class="text-gray-600 text-[15px]">({{ getSizesText(rule.sizes) }})</span>
        }
        </h3>
      <div class="grid 2xl:grid-cols-2 gap-6">
        @for (product of rule.products; track product.id) {
      <div class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
        [class.border-orange-500]="getItemQuantity(rule.id, product.id) > 0"
        [class.shadow-md]="getItemQuantity(rule.id, product.id) > 0"
        [class.opacity-60]="product.available === false"
        [class.cursor-not-allowed]="product.available === false"
        [class.cursor-pointer]="product.available === true">
        @if (product.available === false) {
      <span class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
        Non disponible
      </span>
        }
        <div class="flex items-center space-x-3 flex-1 min-w-0">
        <div class="flex-1 min-w-0">
        <span class="text-base text-site font-medium break-words">{{ product.name }}</span>
      <span class="text-sm text-site font-normal">({{ getProductPrice(product, rule) | number:'1.2-2' }}€)</span>
      </div>
      </div>
      <div class="flex items-center gap-2 flex-shrink-0 mr-3">
      <button (click)="decrementItem(rule.id, product.id)"
        [disabled]="getItemQuantity(rule.id, product.id) === 0"
        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">-</button>
          <span class="font-bold min-w-[20px] text-center text-site">{{ getItemQuantity(rule.id, product.id) }}</span>
      <button [disabled]="product.available === false"
      (click)="incrementItem(rule.id, product.id, ruleIndex)"
        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">+</button>
          </div>
        @if (product.image) {
      <img [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
        [alt]="product.name || 'Image à venir'"
        width="64" height="64" loading="lazy" class="rounded-lg flex-shrink-0">
        }
        </div>
        }
        </div>
      </div>
        }
        }
        </div>
        }
        </div>

      <!-- Bottom bar mobile -->
      <div class="fixed bottom-0 left-0 right-0 bg-[#2B150575] backdrop-blur-md border-b border-orange-900/30 border-t mx-[16px] shadow-lg p-2 z-50">
        @if (!canAddToCart()) {
      <p class="text-[#FF730A] text-xs text-center mb-1 font-medium">{{ getValidationMessage() }}</p>
        }
        <div class="flex items-center justify-center">
      <button (click)="toggleCartSheet()" [disabled]="!canAddToCart()" [class.disabled]="!canAddToCart()"
        class="add bg-[#FF730A] text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 w-full justify-center">
          <span>Voir détails</span>
      </button>
      </div>
      </div>
      </div>

      <!-- --- AFFICHAGE TABLETTE --- -->
      <div class="hidden md:flex xl:hidden gap-4">
        <div class="w-1/3 flex-shrink-0">
        <div class="sticky top-4">
        <div class="flex items-center justify-center mb-4">
        <div class="relative w-full aspect-square">
      <img [ngSrc]="promoSignal()?.image || 'assets/images/promos.webp'"
        [alt]="promoSignal()?.title || 'Image à venir'"
        fill loading="lazy" sizes="33vw" class="rounded-lg object-contain label">
        </div>
        </div>
        <h1 class="text-xl font-semibold mb-2">{{ promoSignal()?.title }}</h1>
        @if (promoSignal()?.payload?.cheapestOffered === true) {
      <div class="bg-[#fcf8e3] border-l-4 border-l-[#8a6d3b] flex items-center mb-0 gap-3 p-3">
        <mat-icon class="warning">warning</mat-icon>
        <p class="text-[#8a6d3b]">La moins chère sera offerte</p>
      </div>
        }
        </div>
      </div>

      <div class="flex-1 overflow-y-auto pr-4">
        <div class="space-y-6">
        @if (hasProductsToBuy()) {
      <div>
        @if (promoSignal()?.payload?.cheapestOffered === false) {
      <h2 class="text-[28px] text-[#FF730A] font-bold mb-0 title">Produits Achetés</h2>
        }
        @for (rule of promoSignal()?.payload?.rules; track rule.id; let ruleIndex = $index) {
        @if (!rule.offered) {
      <div [attr.id]="'tablet-rule-' + ruleIndex">
        <h3 class="text-[22px] text-[#FF730A] font-semibold mb-4">
        {{ rule.quantity }} {{ rule.category.name }}
        @if (rule.sizes && rule.sizes.length > 0) {
      <span class="text-gray-600 text-[15px]">({{ getSizesText(rule.sizes) }})</span>
        }
        </h3>
      <div class="grid 2xl:grid-cols-2 gap-6">
        @for (product of rule.products; track product.id) {
      <div class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
        [class.border-orange-500]="getItemQuantity(rule.id, product.id) > 0"
        [class.shadow-md]="getItemQuantity(rule.id, product.id) > 0"
        [class.opacity-60]="product.available === false"
        [class.cursor-not-allowed]="product.available === false"
        [class.cursor-pointer]="product.available === true">
        @if (product.available === false) {
      <span class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
        Non disponible
      </span>
        }
        <div class="flex items-center space-x-3 flex-1 min-w-0">
        <div class="flex-1 min-w-0">
        <span class="text-base text-site font-medium break-words">{{ product.name }}</span>
      <span class="text-sm text-site font-normal">({{ getProductPrice(product, rule) | number:'1.2-2' }}€)</span>
      </div>
      </div>
      <div class="flex items-center gap-2 flex-shrink-0 mr-3">
      <button (click)="decrementItem(rule.id, product.id)"
        [disabled]="getItemQuantity(rule.id, product.id) === 0"
        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">-</button>
          <span class="font-bold min-w-[20px] text-center text-site">{{ getItemQuantity(rule.id, product.id) }}</span>
      <button [disabled]="product.available === false"
      (click)="incrementItem(rule.id, product.id, ruleIndex)"
        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">+</button>
          </div>
        @if (product.image) {
      <img [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
        [alt]="product.name || 'Image à venir'"
        width="64" height="64" loading="lazy" class="rounded-lg flex-shrink-0">
        }
        </div>
        }
        </div>
      </div>
        }
        }
        </div>
        }

        @if (hasOfferedProducts()) {
      <div>
        @if (promoSignal()?.payload?.cheapestOffered === false) {
      <h2 class="text-[28px] text-[#FF730A] title font-bold mb-0">Produits Offerts</h2>
        }
        @for (rule of promoSignal()?.payload?.rules; track trackItem(rule.id, $index); let ruleIndex = $index) {
                    @if (rule.offered) {
                      <div [attr.id]="'tablet-rule-' + ruleIndex">
                        <h3 class="text-[22px] text-[#FF730A] font-semibold mb-4">
                          {{ rule.quantity }} {{ rule.category.name }}
                          @if (rule.sizes && rule.sizes.length > 0) {
                            <span class="text-gray-600 text-[15px]">({{ getSizesText(rule.sizes) }})</span>
                          }
                        </h3>
                        <div class="grid 2xl:grid-cols-2 gap-6">
                          @for (product of rule.products; track trackItem(product.id, $index)) {
      <div class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
           [class.border-orange-500]="getItemQuantity(rule.id, product.id) > 0"
           [class.shadow-md]="getItemQuantity(rule.id, product.id) > 0"
           [class.opacity-60]="product.available === false"
           [class.cursor-not-allowed]="product.available === false"
           [class.cursor-pointer]="product.available === true">
        @if (product.available === false) {
        <span class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
          Non disponible
        </span>
        }
        <div class="flex items-center space-x-3 flex-1 min-w-0">
          <div class="flex-1 min-w-0">
            <span class="text-base text-site font-medium break-words">{{ product.name }}</span>
            <span class="text-sm text-site font-normal">({{ getProductPrice(product, rule) | number:'1.2-2' }}€)</span>
          </div>
        </div>
        <div class="flex items-center gap-2 flex-shrink-0 mr-3">
          <button (click)="decrementItem(rule.id, product.id)"
                  [disabled]="getItemQuantity(rule.id, product.id) === 0"
                  class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">-</button>
          <span class="font-bold min-w-[20px] text-center text-site">{{ getItemQuantity(rule.id, product.id) }}</span>
          <button [disabled]="product.available === false"
                  (click)="incrementItem(rule.id, product.id, ruleIndex)"
                  class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">+</button>
        </div>
        @if (product.image) {
        <img [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
             [alt]="product.name || 'Image à venir'"
             width="64" height="64" loading="lazy" class="rounded-lg flex-shrink-0">
        }
      </div>
      }
      </div>
      </div>
      }
      }
      </div>
      }
    </div>
  </div>

  <!-- Bottom bar tablette -->
  <div class="fixed bottom-0 left-0 right-0 bg-[#2B150575] backdrop-blur-md border-b border-orange-900/30 border-t mx-[16px] shadow-lg p-2 z-50">
    @if (!canAddToCart()) {
    <p class="text-[#FF730A] text-xs text-center mb-1 font-medium">{{ getValidationMessage() }}</p>
    }
    <div class="flex items-center justify-center">
      <button (click)="toggleCartSheet()" [disabled]="!canAddToCart()" [class.disabled]="!canAddToCart()"
              class="add bg-[#FF730A] text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 w-full justify-center">
        <span>Voir détails</span>
      </button>
    </div>
  </div>
</div>

<!-- --- MODAL CART SHEET SLIDER (MOBILE & TABLETTE) --- -->
@if (isCartSheetOpen) {
<div class="fixed inset-0 z-[60]" (click)="toggleCartSheet()">
<div class="absolute inset-0 bg-neutral transition-opacity duration-300"
[class.opacity-50]="isCartSheetOpen" [class.opacity-0]="!isCartSheetOpen"></div>
<div (click)="$event.stopPropagation()"
class="absolute bottom-0 left-0 right-0 bg-base-200 rounded-t-2xl shadow-2xl max-h-[85vh] flex flex-col">
<div class="flex justify-end pt-3 pr-3">
<mat-icon class="text-gray-300 cursor-pointer" (click)="toggleCartSheet()">close</mat-icon>
</div>
<div class="flex justify-between items-start p-3">
<div class="flex-1">
<h2 class="font-semibold title">{{ promoSignal()?.title }}</h2>
</div>
</div>
<div class="flex-1 overflow-y-auto px-4 py-2 space-y-4" #scrollableContent>
<div class="rounded-[6px]">
<div class="space-y-3">
@if (getSelectedBuyItems().length > 0) {
<div class="rounded-[6px] p-[12px] bg-base-300">
  <div class="flex items-center gap-2 mb-3 pb-2">
    @if (promoSignal()?.payload?.cheapestOffered === false) {
    <span class="text-blue-600 font-semibold text-sm border-b border-gray-300">🛒 Produits Achetés</span>
    }
    @if (promoSignal()?.payload?.reduction?.type === 'FIXED_AMOUNT' && doesBuyItemsGroupHaveReduction()) {
    <span class="text-green-600 text-xs font-semibold bg-green-50 px-2 py-0.5 rounded ml-auto">
    {{ getFixedAmountReductionBadge() }}
    </span>
    }
  </div>
  @for (item of getSelectedBuyItems(); track trackItem(item.product, $index)) {
  <div class="mb-2 pb-2 border-b border-gray-100 last:border-b-0">
    @for (i of [].constructor(item.quantity); track trackItem(i, index); let index = $index) {
  <div class="product-item" [class.mt-2]="index > 0">
    <div class="flex justify-between items-start mb-1">
      <div class="flex-1">
        <div class="flex items-center flex-wrap gap-1">
          <span class="text-sm text-site font-medium">{{ item.product.name }}</span>
          @if (item.rule.sizes && item.rule.sizes.length > 0) {
          <span class="text-gray-500 text-xs">({{ getSizesText(item.rule.sizes) }})</span>
          }
          @if (item.quantity > 1) {
          <span class="text-gray-500 text-xs">#{{ index + 1 }}</span>
          }
          @if (doesItemHaveReduction(item.rule.id, item.product.id) && promoSignal()?.payload?.reduction?.type === 'PERCENTAGE') {
          <span class="inline-block text-green-600 text-[10px] font-semibold bg-green-50 px-1.5 py-0.5 rounded mt-1">
          {{ getReductionText() }}
          </span>
          }
        </div>
        @if (customizableItems[item.rule.id + '_' + item.product.id]) {
        <div class="mt-1">
          <span (click)="openProductCustomization(item.product, item.rule.id, index);$event.stopPropagation()"
                class="inline-flex items-center text-xs cursor-pointer hover:text-[#e66609] transition-colors"
                [class.text-[#888888]]="!hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)"
                [class.text-red-600]="hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)"
                [class.underline]="true">
            @if (isItemCustomized(item.rule.id, item.product.id, index) || hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)) {
        <mat-icon class="material-symbols-outlined text-sm mr-1">
          {{ hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index) ? 'warning' : '' }}
        </mat-icon>
        }
        {{ isItemCustomized(item.rule.id, item.product.id, index) ? (hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index) ? 'Compléter' : 'Modifier') : 'Personnaliser' }}
        </span>
      </div>
        }
      </div>
      <div class="text-right">
        @if (shouldShowStrikethroughPrice(item.rule.id, item.product.id)) {
        <div class="text-xs text-gray-400 line-through">
        {{ truncate2(getItemBasePriceOnly(item.rule.id, item.product.id, index)) | number:'1.2-2' }}€
                                      </div>
        }
        <div class="font-semibold"
             [class.text-green-600]="shouldShowGreenPrice(item.rule.id, item.product.id)"
             [class.text-site]="!shouldShowGreenPrice(item.rule.id, item.product.id)">
          {{ truncate2(getItemDisplayPrice(item.rule.id, item.product.id, index)) | number:'1.2-2' }}€
        </div>
      </div>
      <mat-icon class="material-symbols-outlined icon cursor-pointer text-red-500 hover:text-red-700 transition-colors ml-2"
                (click)="removeItem(item.rule.id, item.product.id, index)"
                title="Supprimer">delete</mat-icon>
    </div>
    @if (getCustomizationSummary(item.rule.id, item.product.id, index).trim() !== '') {
    <div class="mt-2 ml-1">
      <div class="rounded-md px-2 py-1.5 text-xs">
        <div class="text-gray-400 leading-relaxed">
          @for (line of getCustomizationSummary(item.rule.id, item.product.id, index).split('\n'); track trackItem(line, $index)) {
    <div>
      @if (line.startsWith('➕ Suppléments')) {
      <span>{{ line.split(':')[0] }} : </span>
                                              @for (part of line.split(':')[1].split('|||'); track trackItem(part, $index); let last = $last) {
      @if (part.includes('[CAT]')) {
      <span class="text-primary font-semibold">
      {{ part.split('-')[0].replace('[CAT]', '').trim() }}
      </span>
      - {{ part.split('-').slice(1).join('-') }}
      } @else {
      {{ part }}
      }
      @if (!last) { <span>, </span> }
      }
      } @else {
      {{ line }}
      }
    </div>
    }
    </div>
  </div>
</div>
    }
  </div>
  }
  </div>
  }
</div>
}

@if (getOfferedItems().length > 0) {
<div class="rounded-[6px] p-[12px] bg-base-300">
  <div class="flex items-center gap-1 mb-3 pb-2">
    @if (promoSignal()?.payload?.cheapestOffered === false) {
    <span class="text-green-600 font-semibold text-sm border-b border-green-200">🎁 Produits Offerts</span>
    }
    @if (promoSignal()?.payload?.reduction?.type === 'FIXED_AMOUNT' && doesOfferedItemsGroupHaveReduction()) {
    <span class="text-green-600 text-xs font-semibold bg-green-50 px-2 py-0.5 rounded ml-auto">
    {{ getFixedAmountReductionBadge() }}
    </span>
    }
    @if (promoSignal()?.payload?.reduction?.type === 'SET_PRICE') {
    <div class="flex justify-end">
      <span class="text-green-600 text-xs font-semibold bg-green-50 px-2 py-0.5 rounded ml-auto">
    {{ promoSignal()?.payload?.reduction?.value | number:'1.2-2' }} €
                              </span>
                            </div>
    }
  </div>
  @for (item of getOfferedItems(); track trackItem(item.rule, $index)) {
  <div class="mb-2 pb-2 border-b border-gray-100 last:border-b-0">
    @for (i of [].constructor(item.quantity); track trackItem(i, index); let index = $index) {
  <div class="product-item" [class.mt-2]="index > 0">
    <div class="flex justify-between items-start mb-1">
      <div class="flex-1">
        <div class="flex items-center flex-wrap gap-1">
          <span class="text-sm text-site font-medium">{{ item.product.name }}</span>
          @if (item.rule.sizes && item.rule.sizes.length > 0) {
          <span class="text-gray-500 text-xs">({{ getSizesText(item.rule.sizes) }})</span>
          }
          @if (item.quantity > 1) {
          <span class="text-gray-500 text-xs">#{{ index + 1 }}</span>
          }
          @if (doesItemHaveReduction(item.rule.id, item.product.id) && promoSignal()?.payload?.reduction?.type === 'PERCENTAGE') {
          <span class="inline-block text-green-600 text-[10px] font-semibold bg-green-50 px-1.5 py-0.5 rounded mt-1">
          {{ getReductionText() }}
          </span>
          }
        </div>
        @if (customizableItems[item.rule.id + '_' + item.product.id]) {
        <div class="mt-1">
          <span (click)="openProductCustomization(item.product, item.rule.id, index);$event.stopPropagation()"
                class="inline-flex items-center text-xs cursor-pointer hover:text-[#e66609] transition-colors"
                [class.text-[#888888]]="!hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)"
                [class.text-red-600]="hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)"
                [class.underline]="true">
            @if (isItemCustomized(item.rule.id, item.product.id, index) || hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)) {
        <mat-icon class="material-symbols-outlined text-sm mr-1">
          {{ hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index) ? 'warning' : '' }}
        </mat-icon>
        }
        {{ isItemCustomized(item.rule.id, item.product.id, index) ? (hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index) ? 'Compléter' : 'Modifier') : 'Personnaliser' }}
        </span>
      </div>
        }
      </div>
      @if (promoSignal()?.payload?.reduction?.type !== 'SET_PRICE') {
      <div class="text-right">
        @if (shouldShowStrikethroughPrice(item.rule.id, item.product.id)) {
      <div class="text-xs text-gray-400 line-through">
        {{ truncate2(getItemBasePriceOnly(item.rule.id, item.product.id, index)) | number:'1.2-2' }}€
      </div>
      }
      <div class="font-semibold"
           [class.text-green-600]="shouldShowGreenPrice(item.rule.id, item.product.id)"
           [class.text-site]="!shouldShowGreenPrice(item.rule.id, item.product.id)">
      {{ truncate2(getItemDisplayPrice(item.rule.id, item.product.id, index)) | number:'1.2-2' }}€
                                      </div>
                                    </div>
      }
      <mat-icon class="material-symbols-outlined icon cursor-pointer text-red-500 hover:text-red-700 transition-colors ml-2"
                (click)="removeItem(item.rule.id, item.product.id, index)"
                title="Supprimer">delete</mat-icon>
    </div>
    @if (getCustomizationSummary(item.rule.id, item.product.id, index).trim() !== '') {
    <div class="mt-2 ml-1">
      <div class="rounded-md px-2 py-1.5 text-xs">
        <div class="text-gray-400 leading-relaxed">
          @for (line of getCustomizationSummary(item.rule.id, item.product.id, index).split('\n'); track trackItem(line, $index)) {
    <div>
      @if (line.startsWith('➕ Suppléments')) {
      <span>{{ line.split(':')[0] }} : </span>
                                              @for (part of line.split(':')[1].split('|||'); track trackItem(part, $index); let last = $last) {
      @if (part.includes('[CAT]')) {
      <span class="text-primary font-semibold">
      {{ part.split('-')[0].replace('[CAT]', '').trim() }}
      </span>
      - {{ part.split('-').slice(1).join('-') }}
      } @else {
      {{ part }}
      }
      @if (!last) { <span>, </span> }
                                              }
                                            } @else {
                                              {{ line }}
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }

                    @if (getSelectedBuyItems().length === 0 && getOfferedItems().length === 0) {
                      <div class="text-center text-gray-400 text-sm py-4">Sélectionnez vos produits</div>
                    }
                  </div>
                </div>
              </div>

              <div class="p-4 bg-base-200 flex flex-col gap-3">
                <div class="space-y-3 text-sm">
                  @if (getTotalSupplementsPrice() > 0) {
                    <div class="flex justify-between font-semibold pt-1">
                      <span>Suppléments</span>
                      <span class="text-green-600">+{{ truncate2(getTotalSupplementsPrice()) | number:'1.2-2' }}€</span>
                    </div>
                  }
                  @if (getTotalReductionAmount() > 0 && !isSetPriceReduction()) {
                    <div class="flex justify-between font-semibold pt-1">
                      <span>Total avant réduction</span>
                      <span class="text-gray-500">{{ getTotalBeforeReduction() | number:'1.2-2' }}€</span>
                    </div>
                  }
                  @if (getTotalReductionAmount() > 0 && !isSetPriceReduction()) {
                    <div class="flex justify-between font-semibold">
                      <span>Réduction</span>
                      <span class="text-[#EB3D08]">-{{ getTotalReductionAmount() | number:'1.2-2' }}€</span>
                    </div>
                  }
                  @if (getSelectedBuyItems().length > 0 && getOfferedItems().length > 0) {
                    <div class="flex justify-between">
                      <span class="text-site font-bold text-lg">Total</span>
                      <div class="text-right">
                        <div class="text-site font-bold text-xl">{{ calculatePromotionTotal() | number:'1.2-2' }}€</div>
                      </div>
                    </div>
                  }
                </div>
                <button [matButton]="themeConfig.appearance.button.action"
                        [disabled]="!canAddToCart() || isSubmitting()" class="w-full py-2" (click)="addToCart()">
                  Ajouter au panier
                </button>
                @if (getValidationMessage() !== '') {
                  <div class="mt-3 p-3">
                    <p class="text-sm text-red-500 flex items-center">
                      <mat-icon class="material-symbols-outlined text-sm mr-1">warning</mat-icon>
                      {{ getValidationMessage() }}
                    </p>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <!-- --- AFFICHAGE DESKTOP --- -->
        <div class="hidden xl:flex gap-4">
          <div class="w-1/4 flex-shrink-0">
            <div class="sticky top-4">
              <div class="flex items-center justify-center mb-4">
                <div class="relative w-full aspect-square">
                  <img [ngSrc]="promoSignal()?.image || 'assets/images/promos.webp'"
                       [alt]="promoSignal()?.title || 'Image à venir'"
                       fill loading="lazy" sizes="33vw" class="rounded-lg object-contain label">
                </div>
              </div>
              <h1 class="text-xl font-semibold mb-2">{{ promoSignal()?.title }}</h1>
              @if (promoSignal()?.payload?.cheapestOffered === true) {
                <div class="bg-[#fcf8e3] border-l-4 border-l-[#8a6d3b] flex items-center gap-3 p-3">
                  <mat-icon class="warning">warning</mat-icon>
                  <p class="text-[#8a6d3b]">La moins chère sera offerte</p>
                </div>
              }
            </div>
          </div>

          <div class="flex-1 overflow-y-auto pr-4">
            <div class="space-y-6">
              @if (hasProductsToBuy()) {
                <div>
                  @if (promoSignal()?.payload?.cheapestOffered === false) {
                    <h2 class="text-[28px] text-[#FF730A] font-bold mb-0 title">Produits Achetés</h2>
                  }
                  @for (rule of promoSignal()?.payload?.rules; track rule.id; let ruleIndex = $index) {
                    @if (!rule.offered) {
                      <div [attr.id]="'desktop-rule-' + ruleIndex">
                        <h3 class="text-[22px] text-[#FF730A] font-semibold mb-4">
                          {{ rule.quantity }} {{ rule.category.name }}
                          @if (rule.sizes && rule.sizes.length > 0) {
                            <span class="text-gray-600 text-[15px]">({{ getSizesText(rule.sizes) }})</span>
                          }
                        </h3>
                        <div class="grid 2xl:grid-cols-2 gap-6">
                          @for (product of rule.products; track product.id) {
                            <div class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
                                 [class.border-orange-500]="getItemQuantity(rule.id, product.id) > 0"
                                 [class.shadow-md]="getItemQuantity(rule.id, product.id) > 0"
                                 [class.opacity-60]="product.available === false"
                                 [class.cursor-not-allowed]="product.available === false"
                                 [class.cursor-pointer]="product.available === true">
                              @if (product.available === false) {
                                <span class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                                  Non disponible
                                </span>
                              }
                              <div class="flex items-center space-x-3 flex-1 min-w-0">
                                <div class="flex-1 min-w-0">
                                  <span class="text-base text-site font-medium break-words">{{ product.name }}</span>
                                  <span class="text-sm text-site font-normal">({{ getProductPrice(product, rule) | number:'1.2-2' }}€)</span>
                                </div>
                              </div>
                              <div class="flex items-center gap-2 flex-shrink-0 mr-3">
                                <button (click)="decrementItem(rule.id, product.id)"
                                        [disabled]="getItemQuantity(rule.id, product.id) === 0"
                                        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">-</button>
                                <span class="font-bold min-w-[20px] text-center text-site">{{ getItemQuantity(rule.id, product.id) }}</span>
                                <button [disabled]="product.available === false"
                                        (click)="incrementItem(rule.id, product.id, ruleIndex)"
                                        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">+</button>
                              </div>
                              @if (product.image) {
                                <img [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
                                     [alt]="product.name || 'Image à venir'"
                                     width="64" height="64" loading="lazy" class="rounded-lg flex-shrink-0">
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>
              }

              @if (hasOfferedProducts()) {
                <div>
                  @if (promoSignal()?.payload?.cheapestOffered === false) {
                    <h2 class="text-[28px] text-[#FF730A] title font-bold mb-0">Produits Offerts</h2>
                  }
                  @for (rule of promoSignal()?.payload?.rules; track rule.id; let ruleIndex = $index) {
                    @if (rule.offered) {
                      <div [attr.id]="'desktop-rule-' + ruleIndex">
                        <h3 class="text-[22px] text-[#FF730A] font-semibold mb-4">
                          {{ rule.quantity }} {{ rule.category.name }}
                          @if (rule.sizes && rule.sizes.length > 0) {
                            <span class="text-gray-600 text-[15px]">({{ getSizesText(rule.sizes) }})</span>
                          }
                        </h3>
                        <div class="grid 2xl:grid-cols-2 gap-6">
                          @for (product of rule.products; track product.id) {
                            <div class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
                                 [class.border-orange-500]="getItemQuantity(rule.id, product.id) > 0"
                                 [class.shadow-md]="getItemQuantity(rule.id, product.id) > 0"
                                 [class.opacity-60]="product.available === false"
                                 [class.cursor-not-allowed]="product.available === false"
                                 [class.cursor-pointer]="product.available === true">
                              @if (product.available === false) {
                                <span class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                                  Non disponible
                                </span>
                              }
                              <div class="flex items-center space-x-3 flex-1 min-w-0">
                                <div class="flex-1 min-w-0">
                                  <span class="text-base text-site font-medium break-words">{{ product.name }}</span>
                                  <span class="text-sm text-site font-normal">({{ getProductPrice(product, rule) | number:'1.2-2' }}€)</span>
                                </div>
                              </div>
                              <div class="flex items-center gap-2 flex-shrink-0 mr-3">
                                <button (click)="decrementItem(rule.id, product.id)"
                                        [disabled]="getItemQuantity(rule.id, product.id) === 0"
                                        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">-</button>
                                <span class="font-bold min-w-[20px] text-center text-site">{{ getItemQuantity(rule.id, product.id) }}</span>
                                <button [disabled]="product.available === false"
                                        (click)="incrementItem(rule.id, product.id, ruleIndex)"
                                        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center hover:text-[#1a1a1a] justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all">+</button>
                              </div>
                              @if (product.image) {
                                <img [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
                                     [alt]="product.name || 'Image à venir'"
                                     width="64" height="64" loading="lazy" class="rounded-lg flex-shrink-0">
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          </div>

          <div class="w-80 flex-shrink-0">
            <div class="sticky top-4 flex flex-col bg-base-200 shadow-md rounded-[10px] p-[8px] h-auto max-h-[80vh]">
              <h2 class="font-semibold mb-4">{{ promoSignal()?.title }}</h2>
              <div class="flex flex-col flex-1 rounded-[6px] overflow-hidden">
                <div class="flex-1 overflow-y-auto p-3">
                  <div class="space-y-3">
                    @if (getSelectedBuyItems().length > 0) {
                      <div class="rounded-[6px] p-[12px] bg-base-300">
                        <div class="flex items-center gap-2 mb-3 pb-2">
                          @if (promoSignal()?.payload?.cheapestOffered === false) {
                            <span class="text-blue-600 font-semibold text-sm border-b border-gray-300">🛒 Produits Achetés</span>
                          }
                          @if (promoSignal()?.payload?.reduction?.type === 'FIXED_AMOUNT' && doesBuyItemsGroupHaveReduction()) {
                            <span class="text-green-600 text-xs font-semibold bg-green-50 px-2 py-0.5 rounded ml-auto">
                              {{ getFixedAmountReductionBadge() }}
                            </span>
                          }
                        </div>
                        @for (item of getSelectedBuyItems(); track trackItem(item.product, $index)) {
      <div class="mb-2 pb-2 border-b border-gray-100 last:border-b-0">
        @for (i of [].constructor(item.quantity); track trackItem(i, index); let index = $index) {
        <div class="product-item" [class.mt-2]="index > 0">
          <div class="flex justify-between items-start mb-1">
            <div class="flex-1">
              <div class="flex items-center flex-wrap gap-1">
                <span class="text-sm text-site font-medium">{{ item.product.name }}</span>
                                      @if (item.rule.sizes && item.rule.sizes.length > 0) {
        <span class="text-gray-500 text-xs">({{ getSizesText(item.rule.sizes) }})</span>
        }
        @if (item.quantity > 1) {
        <span class="text-gray-500 text-xs">#{{ index + 1 }}</span>
        }
        @if (doesItemHaveReduction(item.rule.id, item.product.id) && promoSignal()?.payload?.reduction?.type === 'PERCENTAGE') {
        <span class="inline-block text-green-600 text-[10px] font-semibold bg-green-50 px-1.5 py-0.5 rounded mt-1">
                                          {{ getReductionText() }}
                                        </span>
        }
        </div>
        @if (customizableItems[item.rule.id + '_' + item.product.id]) {
        <div class="mt-1">
                                        <span (click)="openProductCustomization(item.product, item.rule.id, index);$event.stopPropagation()"
                                              class="inline-flex items-center text-xs cursor-pointer hover:text-[#e66609] transition-colors"
                                              [class.text-[#888888]]="!hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)"
                                              [class.text-red-600]="hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)"
                                              [class.underline]="true">
                                          @if (isItemCustomized(item.rule.id, item.product.id, index) || hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)) {
                                          <mat-icon class="material-symbols-outlined text-sm mr-1">
                                              {{ hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index) ? 'warning' : '' }}
                                            </mat-icon>
                                          }
                                          {{ isItemCustomized(item.rule.id, item.product.id, index) ? (hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index) ? 'Compléter' : 'Modifier') : 'Personnaliser' }}
                                        </span>
        </div>
        }
        </div>
        <div class="text-right">
          @if (shouldShowStrikethroughPrice(item.rule.id, item.product.id)) {
        <div class="text-xs text-gray-400 line-through">
          {{ truncate2(getItemBasePriceOnly(item.rule.id, item.product.id, index)) | number:'1.2-2' }}€
        </div>
        }
        <div class="font-semibold"
             [class.text-green-600]="shouldShowGreenPrice(item.rule.id, item.product.id)"
             [class.text-site]="!shouldShowGreenPrice(item.rule.id, item.product.id)">
        {{ truncate2(getItemDisplayPrice(item.rule.id, item.product.id, index)) | number:'1.2-2' }}€
                                    </div>
                                  </div>
                                  <mat-icon class="material-symbols-outlined icon cursor-pointer text-red-500 hover:text-red-700 transition-colors ml-2"
                                            (click)="removeItem(item.rule.id, item.product.id, index)"
                                            title="Supprimer">delete</mat-icon>
                                </div>
                                @if (getCustomizationSummary(item.rule.id, item.product.id, index).trim() !== '') {
        <div class="mt-2 ml-1">
          <div class="rounded-md px-2 py-1.5 text-xs">
            <div class="text-gray-400 leading-relaxed">
              @for (line of getCustomizationSummary(item.rule.id, item.product.id, index).split('\n'); track trackItem(line, $index)) {
              <div>
                @if (line.startsWith('➕ Suppléments')) {
              <span>{{ line.split(':')[0] }} : </span>
              @for (part of line.split(':')[1].split('|||'); track trackItem(part, $index); let last = $last) {
              @if (part.includes('[CAT]')) {
              <span class="text-primary font-semibold">
                                                    {{ part.split('-')[0].replace('[CAT]', '').trim() }}
                                                  </span>
              - {{ part.split('-').slice(1).join('-') }}
              } @else {
              {{ part }}
              }
              @if (!last) { <span>, </span> }
              }
              } @else {
              {{ line }}
              }
              </div>
              }
            </div>
          </div>
        </div>
        }
        </div>
        }
      </div>
      }
      </div>
      }

      @if (getOfferedItems().length > 0) {
      <div class="rounded-[6px] p-[12px] bg-base-300">
        <div class="flex items-center gap-1 mb-3 pb-2">
          @if (promoSignal()?.payload?.cheapestOffered === false) {
      <span class="text-green-600 font-semibold text-sm border-b border-green-200">🎁 Produits Offerts</span>
      }
      @if (promoSignal()?.payload?.reduction?.type === 'FIXED_AMOUNT' && doesOfferedItemsGroupHaveReduction()) {
      <span class="text-green-600 text-xs font-semibold bg-green-50 px-2 py-0.5 rounded ml-auto">
                              {{ getFixedAmountReductionBadge() }}
                            </span>
      }
      @if (promoSignal()?.payload?.reduction?.type === 'SET_PRICE') {
      <div class="flex justify-end">
                              <span class="text-green-600 text-xs font-semibold bg-green-50 px-2 py-0.5 rounded ml-auto">
                                {{ promoSignal()?.payload?.reduction?.value | number:'1.2-2' }} €
                              </span>
      </div>
      }
      </div>
      @for (item of getOfferedItems(); track trackItem(item.rule, $index)) {
      <div class="mb-2 pb-2 border-b border-gray-100 last:border-b-0">
        @for (i of [].constructor(item.quantity); track trackItem(i, index); let index = $index) {
        <div class="product-item" [class.mt-2]="index > 0">
          <div class="flex justify-between items-start mb-1">
            <div class="flex-1">
              <div class="flex items-center flex-wrap gap-1">
                <span class="text-sm text-site font-medium">{{ item.product.name }}</span>
                                      @if (item.rule.sizes && item.rule.sizes.length > 0) {
        <span class="text-gray-500 text-xs">({{ getSizesText(item.rule.sizes) }})</span>
        }
        @if (item.quantity > 1) {
        <span class="text-gray-500 text-xs">#{{ index + 1 }}</span>
        }
        @if (doesItemHaveReduction(item.rule.id, item.product.id) && promoSignal()?.payload?.reduction?.type === 'PERCENTAGE') {
        <span class="inline-block text-green-600 text-[10px] font-semibold bg-green-50 px-1.5 py-0.5 rounded mt-1">
                                          {{ getReductionText() }}
                                        </span>
        }
        </div>
        @if (customizableItems[item.rule.id + '_' + item.product.id]) {
        <div class="mt-1">
                                        <span (click)="openProductCustomization(item.product, item.rule.id, index);$event.stopPropagation()"
                                              class="inline-flex items-center text-xs cursor-pointer hover:text-[#e66609] transition-colors"
                                              [class.text-[#888888]]="!hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)"
                                              [class.text-red-600]="hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)"
                                              [class.underline]="true">
                                          @if (isItemCustomized(item.rule.id, item.product.id, index) || hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index)) {
                                          <mat-icon class="material-symbols-outlined text-sm mr-1">
                                              {{ hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index) ? 'warning' : '' }}
                                            </mat-icon>
                                          }
                                          {{ isItemCustomized(item.rule.id, item.product.id, index) ? (hasIncompleteRequiredCustomizations(item.rule.id, item.product.id, index) ? 'Compléter' : 'Modifier') : 'Personnaliser' }}
                                        </span>
        </div>
        }
        </div>
        @if (promoSignal()?.payload?.reduction?.type !== 'SET_PRICE') {
        <div class="text-right">
          @if (shouldShowStrikethroughPrice(item.rule.id, item.product.id)) {
          <div class="text-xs text-gray-400 line-through">
          {{ truncate2(getItemBasePriceOnly(item.rule.id, item.product.id, index)) | number:'1.2-2' }}€
                                        </div>
          }
          <div class="font-semibold"
               [class.text-green-600]="shouldShowGreenPrice(item.rule.id, item.product.id)"
               [class.text-site]="!shouldShowGreenPrice(item.rule.id, item.product.id)">
            {{ truncate2(getItemDisplayPrice(item.rule.id, item.product.id, index)) | number:'1.2-2' }}€
          </div>
        </div>
        }
        <mat-icon class="material-symbols-outlined icon cursor-pointer text-red-500 hover:text-red-700 transition-colors ml-2"
                  (click)="removeItem(item.rule.id, item.product.id, index)"
                  title="Supprimer">delete</mat-icon>
      </div>
      @if (getCustomizationSummary(item.rule.id, item.product.id, index).trim() !== '') {
        <div class="mt-2 ml-1">
          <div class="rounded-md px-2 py-1.5 text-xs">
            <div class="text-gray-400 leading-relaxed">
              @for (line of getCustomizationSummary(item.rule.id, item.product.id, index).split('\n'); track trackItem(line, $index)) {
              <div>
                @if (line.startsWith('➕ Suppléments')) {
              <span>{{ line.split(':')[0] }} : </span>
              @for (part of line.split(':')[1].split('|||'); track trackItem(part, $index); let last = $last) {
              @if (part.includes('[CAT]')) {
              <span class="text-primary font-semibold">
                                                    {{ part.split('-')[0].replace('[CAT]', '').trim() }}
                                                  </span>
              - {{ part.split('-').slice(1).join('-') }}
              } @else {
              {{ part }}
              }
              @if (!last) { <span>, </span> }
              }
              } @else {
              {{ line }}
              }
              </div>
              }
            </div>
          </div>
        </div>
        }
        </div>
        }
      </div>
      }
      </div>
      }

      @if (getSelectedBuyItems().length === 0 && getOfferedItems().length === 0) {
      <div class="text-center text-gray-400 text-sm py-4">Sélectionnez vos produits</div>
      }
    </div>
  </div>

  <div class="p-3">
    <div class="space-y-3 text-sm pb-2">
      @if (getTotalSupplementsPrice() > 0) {
      <div class="flex justify-between font-semibold pt-1">
        <span>Suppléments</span>
        <span class="text-green-600">+{{ truncate2(getTotalSupplementsPrice()) | number:'1.2-2' }}€</span>
                      </div>
      }
      @if (getTotalReductionAmount() > 0 && !isSetPriceReduction()) {
      <div class="flex justify-between font-semibold pt-1">
        <span>Total avant réduction</span>
        <span class="text-gray-500">{{ getTotalBeforeReduction() | number:'1.2-2' }}€</span>
                      </div>
      }
      @if (getTotalReductionAmount() > 0 && !isSetPriceReduction()) {
      <div class="flex justify-between font-semibold">
        <span>Réduction</span>
        <span class="text-[#EB3D08]">-{{ getTotalReductionAmount() | number:'1.2-2' }}€</span>
                      </div>
      }
      @if (getSelectedBuyItems().length > 0 && getOfferedItems().length > 0) {
      <div class="flex justify-between">
        <span class="text-site font-bold text-lg">Total</span>
        <div class="text-right">
          <div class="text-site font-bold text-xl">{{ calculatePromotionTotal() | number:'1.2-2' }}€</div>
                        </div>
                      </div>
      }
    </div>

    <button [matButton]="themeConfig.appearance.button.action"
            [disabled]="!canAddToCart() || isSubmitting()" class="w-full py-2" (click)="addToCart()">
      Ajouter au panier
    </button>

    @if (getValidationMessage() !== '') {
    <div class="mt-3 p-3">
      <p class="text-sm text-red-500 flex items-center">
        <mat-icon class="material-symbols-outlined text-sm mr-1">warning</mat-icon>
    {{ getValidationMessage() }}
    </p>
  </div>
    }
  </div>
</div>
</div>
</div>
</div>
}
</div>
}
</div>
